import React from 'react'
import Image from '../../../images/buyerpolicies/Pricing and Availability.png'

const Pricing_and_availability = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Pricing and Availability</h2>
            <p>We always strive hard to ensure the price and availability of the product is regularly updated so the customer does not face any botheration. However, errors can occur occasionally.</p>
            <p>If you order something and the price has been changed, we will let you know the updated price and ask you for a reconfirmation of the order. You can either choose the product at the revised price or cancel it. In case we cannot contact you, we will assume the deal has been canceled. If you have paid online and later cancel the order, you can get a complete refund through your original method of payment.</p>
        </div>
      </div>
    </div>
  )
}

export default Pricing_and_availability
